import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';

import NavFulfillmentIcon from 'base/ui_components/NavFulfillmentIcons.js';

const styles = theme => ({
  root: {
    color: theme.palette.secondary.main,
    '&:hover': {
      opacity: '0.7',
      color: theme.palette.secondary.main
    },
    '& .MuiSvgIcon-root': {
      fill: theme.palette.secondary.main
    }
  }
});

const NavCartButton = ({ onClick, itemsInCart, classes }) => {
  const counter = itemsInCart > 1 ? 'items' : 'item';

  return (
    <IconButton
      onClick={onClick}
      color="secondary"
      classes={classes}
      data-testid="cart-icon"
    >
      <Box mr={0.5} ml={1}>
        <NavFulfillmentIcon icon="cart" />
      </Box>
      {itemsInCart} {counter}
    </IconButton>
  );
};

NavCartButton.propTypes = {
  onClick: PropTypes.func,
  itemsInCart: PropTypes.number,
  classes: PropTypes.object
};

export default withStyles(styles)(NavCartButton);
